import React from 'react';

export const PriorityText = ({task}) => {
	const style = {
		color: task.priority === 'MEDIUM' ? 'rgba(252, 157, 19)' : 'rgba(251, 66, 80)',
		fontSize: '12px',
		fontWeight: 600,
	};
	return <span style={style}>{task.priority}</span>;
};